module.exports = __webpack_public_path__ + "img/smiling-face-with-hearts.63abb3f2.png";